module.exports = __webpack_public_path__ + "img/tiandong_nong.5a9ad177.png";